<div class="mb-button">
  <button
    class="btn btn-primary d-block d-lg-none select-dryers"
    type="button"
    data-bs-toggle="offcanvas"
    data-bs-target="#offcanvasSidenav"
    aria-controls="offcanvasSidenav">
    {{ 'SELECT_DRYER' | translate }}
  </button>
</div>
<div class="container custom">
  <div class="offcanvas offcanvas-start" tabindex="-1" id="offcanvasSidenav" aria-labelledby="offcanvasSidenavLabel">
    <div class="offcanvas-header text-secondary">
      <h3 class="offcanvas-title" id="offcanvasSidenavLabel">{{ 'DRYER_TYPE' | translate }}</h3>
      <button type="button" class="btn-close text-reset custom-close-icon" data-bs-dismiss="offcanvas" aria-label="Close"></button>
    </div>
    <div class="offcanvas-body">
      <app-product-sidenav></app-product-sidenav>
    </div>
  </div>
  <div class="row">
    <div class="col-lg-3 d-none d-lg-block sidenav">
      <div class="card card-body navbar">
        <app-product-sidenav></app-product-sidenav>
      </div>
    </div>

    <div class="col-lg-9 bg-content-body product-content product-details-right-panel">
      <div class="tabs-header">
        <div class="tile-name">
          <h3 class="title fw-bold text-primary">{{ 'DRYERS' | translate }}</h3>
        </div>
        <div class="d-flex flex-column flex-md-row">
          <div class="nav-flex-column nav-pills product-tabs" role="tablist">
            <button
              class="nav-link"
              [ngClass]="isActive('details') ? 'bg-primary text-white' : 'bg-info'"
              routerLink="details"
              routerLinkActive="active"
              (click)="onDetailsTabClick()">
              {{ 'DETAILS' | translate }}
            </button>
            <button
              class="nav-link"
              [ngClass]="isActive('model-comparison') ? 'bg-primary text-white' : 'bg-info'"
              routerLink="model-comparison"
              routerLinkActive="active">
              {{ 'COMPARISON' | translate }}
            </button>
            <button
              class="nav-link"
              [ngClass]="isActive('cost-comparison') ? 'bg-primary text-white' : 'bg-info'"
              routerLink="cost-comparison"
              routerLinkActive="active">
              {{ 'COST_COMPARISON' | translate }}
            </button>
          </div>
        </div>
      </div>
      <div class="card card-body">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
